import { render } from "./DotActions.vue?vue&type=template&id=8de2c07a&scoped=true"
import script from "./DotActions.vue?vue&type=script&lang=js"
export * from "./DotActions.vue?vue&type=script&lang=js"

import "./DotActions.vue?vue&type=style&index=0&id=8de2c07a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de2c07a"]])

export default __exports__